const tooltipMatTableOver = {
  delete: 'Deletar',
  edit: 'Editar',
  true: 'Salvar',
  false: 'Deletar',
  cancel: 'Cancelar',
  add: 'Adicionar'
};

export default tooltipMatTableOver;
